import React from 'react'
import SignUpIntro from '@components/Modals/SignUp/SignUpIntro'

const SignUpInputStep = () => {
    return <SignUpIntro/>
}

export default SignUpInputStep